<template>
  <div class="spider-chart-container">
    <spider-chart
      class="spider-chart-container__spider-chart"
      data-screenshot-target
      :dysfunctions="dysfunctions"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { SpiderChart } from 'universkin-shared';
import { spiderChartDysfunctionsMixin } from 'universkin-shared/src/commonDomainObjects/mixins/spiderChartDysfunctionsMixin';

import rootTypes from '@/store/types';

const LOCALES_FOR_WHICH_LAMBDA_HAS_NO_FONTS = ['zh', 'zh-CN'];

const normalizeLocale = locale => {
  const [language, country] = locale.split('-');

  if (!country) {
    return language.toLowerCase();
  }

  return `${language.toLowerCase()}-${country.toUpperCase()}`;
};

/*
 * The component is used for spider chart image generation
 * by lambda. It's built for chrome desktop screen. No responsiveness
 * nor cross-browserness needed.
 * */
export default {
  name: 'PageSpiderChartGenerator',
  components: { SpiderChart },
  mixins: [spiderChartDysfunctionsMixin],
  props: {
    language: {
      type: String,
      required: true
    },
    scores: {
      type: Object,
      required: true
    }
  },
  computed: {
    dysfunctions() {
      return this.getDysfunctionsList(this.scores);
    }
  },
  created() {
    const locale = normalizeLocale(this.language);
    const safeLocale = LOCALES_FOR_WHICH_LAMBDA_HAS_NO_FONTS.includes(locale) ? 'en' : locale;

    this.setLocale(safeLocale);
  },
  methods: {
    ...mapActions({
      setLocale: rootTypes.actions.SET_LOCALE
    })
  }
};
</script>

<style lang="scss" scoped>
.spider-chart-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: var(--u-color-white);

  &__spider-chart {
    height: 560px;
    width: 670px;
  }
}
</style>
